import React from 'react';
import _ from 'lodash';

import { useNetSuiteLocationSelectFieldQuery } from 'generated/graphql';



export interface IInventoryLocation {
  id: string;
  displayName: string;
}

export interface IData {
  objects: IInventoryLocation[];
}

export function useQuery() {
  const queryTuple = useNetSuiteLocationSelectFieldQuery();

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.inventoryLocations ?? [], (node): IInventoryLocation => ({
        id: node.id,
        displayName: node.name
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
